import { MapMarkerAltSvg } from '@/assets/icons';
import { Button, Modal, Table } from 'antd';

const LocationModal = ({ open, address, setAddressForm, onClose }) => {
  const recordSelected = (record) => {
    setAddressForm(record);
    onClose();
  };

  const columns = [
    {
      title: 'Address',
      dataIndex: 'line1',
      render: (value, record) => (
        <>
          {value}
          <br />
          {record.city}, {record.state}&nbsp;{record.zip}
        </>
      ),
    },
    {
      title: 'County',
      dataIndex: 'county',
      render: (value) => value,
    },
    {
      title: '',
      align: 'right',
      render: (_, record) => (
        <Button type="primary" icon={<MapMarkerAltSvg />} onClick={() => recordSelected(record)}>
          Select
        </Button>
      ),
    },
  ];
  return (
    <Modal title={'ADDRESS VALIDATION RESULTS'} open={open} onCancel={onClose}>
      <Table columns={columns} dataSource={address?.allPossibleLocations} rowKey="zip" size="small" />
    </Modal>
  );
};

export default LocationModal;
